import moment from 'moment';
import * as yup from 'yup';
import { responseErrors } from '../../utils/response';

export const skillMapPropsToValues = ({ modalData: { skill = {} } }) => {
  const { title, skill_dates } = skill;

  const isSkillRecurrence = !!(
    skill_dates &&
    skill_dates[0] &&
    skill_dates[0].start_date
  );
  const recurrence = (isSkillRecurrence && skill_dates[0]) || {};
  const isSkillHasEnd = recurrence.stop_date ? 'on' : 'never';
  const endDate = recurrence.stop_date || moment(new Date()).add(1, 'month');
  const startDate = recurrence.start_date || new Date();
  const multiplicator = recurrence.multiplicator || 1;
  const period = recurrence.period || 'day';

  return {
    defaultSkill: '',
    skillValue: title || '',
    period,
    multiplicator,
    isSkillHasEnd,
    isSkillRecurrence,
    startDate: startDate,
    endDate
  };
};

export const skillValidationSchema = yup.object().shape({
  skillValue: yup
    .string()
    .min(4, 'Skill title must be longer')
    .required('Skill title is required!'),
  multiplicator: yup
    .number()
    .integer('Value must be integer')
    .min(1, 'Value must be more than or equal to 1'),
  startDate: yup.date().required('Date is required'),
  endDate: yup
    .date()
    .when(
      'startDate',
      (startDate, schema) =>
        startDate
          ? schema.min(
              startDate,
              'You cannot set a date less than the start date'
            )
          : schema
    )
    .required('Date is required!')
});

export const handleSkillSubmit = (values, props) => {
  const {
    endDate,
    startDate,
    isSkillHasEnd,
    isSkillRecurrence,
    skillValue,
    period,
    multiplicator
  } = values;

  const {
    setSubmitting,
    setErrors,
    props: { closeModal, addSkill, editSkill, modalData }
  } = props;

  const { skill } = modalData;
  const recurrenceId = skill && skill.skill_dates[0] && skill.skill_dates[0].id;

  const skillRecurrence = isSkillRecurrence
    ? {
        id: recurrenceId,
        start_date: startDate,
        stop_date: isSkillHasEnd === 'on' ? endDate : null,
        period: period,
        multiplicator: multiplicator
      }
    : {
        id: recurrenceId,
        start_date: null,
        stop_date: null,
        period: null,
        multiplicator: null
      };

  const data = {
    title: skillValue,
    skill_dates: [skillRecurrence]
  };

  const onSuccess = () => {
    setSubmitting(false);
    closeModal();
  };

  const onError = response => {
    setErrors(responseErrors(response));
    setSubmitting(false);
  };

  skill &&
    editSkill({ id: skill.id, data })
      .then(onSuccess)
      .catch(onError);

  !skill &&
    addSkill(data)
      .then(onSuccess)
      .catch(onError);
};



// WEBPACK FOOTER //
// ./src/containers/Skills/helpers.js